import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../types/store';
import {
  getActiveSection,
  getIsUploadPage,
  getTableLayout,
  getIsGridLayoutSupported,
} from '../../selectors/studio';
import { Props } from './StudioTableDesktop';

export type StateProps = Pick<
  Props,
  'tableLayout' | 'activeSection' | 'canDropFiles' | 'isGridLayoutSupported'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  tableLayout: getTableLayout(state),
  activeSection: getActiveSection(state),
  canDropFiles: getIsUploadPage(state),
  isGridLayoutSupported: getIsGridLayoutSupported(state),
});

export default connect(mapStateToProps);
